import { render, staticRenderFns } from "./Dec.vue?vue&type=template&id=67c55099&scoped=true"
import script from "./Dec.vue?vue&type=script&lang=js"
export * from "./Dec.vue?vue&type=script&lang=js"
import style0 from "./Dec.vue?vue&type=style&index=0&id=67c55099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c55099",
  null
  
)

export default component.exports